'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _text = require('@hixme-ui/text');

_text.Label.displayName = 'hui:Label';
_text.Label.huiName = 'Label';

exports.default = _text.Label;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../label/lib/index.js
// module id = 88
// module chunks = 0